import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const handleJoinClick = () => {
    window.dispatchEvent(new CustomEvent('openPayPalModal'));
  };

  return (
    <footer className="site-footer">
      <div className="container">
        {/* Footer CTA Section */}
        <div className="footer-cta-section">
          <div className="footer-cta-content">
            <h3 className="footer-cta-title">Bereit, dein Template-Business zu starten?</h3>
            <p className="footer-cta-text">
              Sichere dir jetzt Zugang zu täglich neuen verkaufsfertigen Canva-Templates 
              mit vollständigen Resell-Rechten für nur 59€/Monat.
            </p>
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              onClick={handleJoinClick}
            >
              Jetzt Mitglied werden – 59 €/Monat
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>

        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_creator-toolkit-18/artifacts/4urdmjk2_pixel56%20logo%28500%20x%20300%20px%29.png" 
              alt="Pixel56 Logo" 
              className="footer-logo"
            />
            <p className="footer-description">
              Täglich neue Canva-Templates mit voller Resell-Freiheit. 
              Für Freelancer, Agenturen und Dienstleister.
            </p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Kontakt</h4>
            <ul className="footer-links">
              <li>
                <Mail size={16} />
                <a href="mailto:info@pixel56.de">info@pixel56.de</a>
              </li>
              <li>
                <Phone size={16} />
                <a href="tel:026229898654">02622-9898654</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>Hüttenstraße 100, 56170 Bendorf</span>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Rechtliches</h4>
            <ul className="footer-links">
              <li><Link to="/impressum">Impressum</Link></li>
              <li><Link to="/datenschutz">Datenschutz</Link></li>
              <li><Link to="/agb">AGB</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">© {new Date().getFullYear()} Pixel56 – Alle Rechte vorbehalten.</p>
          <p className="footer-notice">
            Volle Resell-Rechte = verkaufe frei weiter. Nur Lizenz-Weitergabe (PLR/MRR) nicht erlaubt.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
